import TimeSheets from "../../components/AllRecords";

const TimeSheet = () => {
  return (
    <>
      <TimeSheets />
    </>
  );
};

export default TimeSheet;
